import { DecimalPipe } from "@angular/common";
import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { BusySpinnerComponent } from "@components/busy/busy-spinner/busy-spinner.component";
import { BlockComponent } from "@components/container-block/block.component";
import { LabelComponent } from "@components/label/label.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { NgbActiveModal, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { sumBy } from "lodash";
import { DateUtils } from "~app/common/utils/date-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ITplMottagningsplatsLeveransplan } from "../../models/dtos";
import { TplService } from "../../services/tpl.service";
import { GaugeChartComponent } from "./gauge-chart/gauge-chart.component";
import { TaktChartComponent } from "./takt-chart/takt-chart.component";

@Component({
    selector: "rask-tpl-mottagningsplats-modal",
    templateUrl: "./tpl-mottagningsplats-modal.component.html",
    styleUrls: ["./tpl-mottagningsplats-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BusySpinnerComponent,
        BlockComponent,
        TabsComponent,
        TabComponent,
        GaugeChartComponent,
        TaktChartComponent,
        LabelComponent,
        DecimalPipe
    ]
})
export class TplMottagningsplatsModalComponent implements OnInit {
    data: ITplMottagningsplatsLeveransplan = null;
    month: string;
    mottagningsplatsId: number;

    private readonly activeModal = inject(NgbActiveModal);
    private readonly tplService = inject(TplService);

    static open(
        mottagningsplatsId: number,
        modalService: NgbModal,
        callBack: (result: any) => void = null) {
        const options = {
            keyboard: false,
            backdrop: "static",
            centered: true,
            windowClass: "modal-size"
        } as NgbModalOptions;
        const modalRef = modalService.open(this, options);
        modalRef.componentInstance.mottagningsplatsId = mottagningsplatsId;

        if (callBack) {
            modalRef.result.then(r => callBack(r));
        } else {
            modalRef.result.then(r => modalRef.close(r));
        }
    }

    close() {
        this.activeModal.close();
    }

    getMonth(period: Date) {
        if (ObjectUtils.hasValue(period)) {
            const date = new Date(period);
            return `${DateUtils.getMonthName(date)} ${date.getFullYear()}`;
        }
        return null;
    }

    ngOnInit(): void {
        this.tplService.getMottagninsplatsLeveransplan(this.mottagningsplatsId).subscribe((res: ITplMottagningsplatsLeveransplan) => {
            this.data = res;
            this.month = this.getMonth(this.data.period);
            this.setLeveransData();
        });
    }

    private setLeveransData() {
        this.data.handelssortiment.forEach(hs => {
            hs.leveransData = [];
            hs.leveransData.push({ namn: "Leveransrad",
                value: hs.leveransradVolym });
            const allLeveransdata = [
                ...hs.produktionsomraden,
                ...hs.terminaler,
                ...hs.leverantorsorder
            ];

            hs.leveransData.push({ namn: "Planerat",
                value: sumBy(allLeveransdata, x => x.planeradVolym) });
            hs.leveransData.push({ namn: "Transporterat",
                value: sumBy(allLeveransdata, x => x.transporteradVolym) });
            hs.leveransData.push({ namn: "Destinerad väglager",
                value: sumBy(allLeveransdata, x => x.destineradVaglagerVolym) });
        });
    }
}
